import React from "react";

const privacyData = {
  title: "Privacy & Policy",
  

  sections: [
    {
      heading: "Privacy & Policy",
      body:
        "Biggestfan is a next-generation short-form video platform designed to empower creativity, connection, and expression. We bring together a diverse global community where users can share moments, stories, talents, and ideas through engaging, vertical videos — commonly known as Reels.",
    },
    {
      heading: "Our Mission",
      body:
        "Our mission is simple: to inspire people to create and share. Biggestfan aims to provide an intuitive and safe platform for creators and viewers alike — a place where imagination meets opportunity, and every voice can find its audience. We believe everyone has something worth sharing, and Biggestfan is the stage where that happens.",
    },
    {
      heading: "What Makes Biggestfan Unique",
      body:
        "Unlike traditional social platforms, Biggestfan puts video at the forefront. With a feed tailored to your interests, a seamless creation toolset, and algorithmic discovery, Biggestfan lets both new and seasoned creators grow organically. Our tools are lightweight yet powerful — built with simplicity and speed in mind.",
    },
    {
      heading: "Community First",
      body:
        "Our users are at the heart of everything we do. Whether you're a content creator, viewer, or brand, Biggestfan is committed to fostering a community where everyone feels seen, heard, and respected. We enforce strict community guidelines to ensure the platform remains positive, inclusive, and respectful for all.",
    },
    {
      heading: "Safety and Integrity",
      body:
        "We are dedicated to user safety and transparency. From content moderation to reporting tools, every feature is designed with user trust in mind. We collaborate with experts, educators, and organizations to ensure our policies evolve with the changing digital landscape, especially when it comes to minors and sensitive content.",
    },
    {
      heading: "Our Technology",
      body:
        "Built with modern technology and a focus on performance, Biggestfan supports smooth video playback, real-time interaction, and scalable content delivery. Our discovery engine helps surface content that's both relevant and diverse, so users can constantly discover new creators and trends that match their vibe.",
    },
    {
      heading: "Join the Biggestfan Movement",
      body: "Whether you're here to laugh, learn, inspire, or be inspired, Biggestfan is your space to explore and express. Every day, creators from around the world share their moments — from quick tutorials and behind-the-scenes footage to dance trends and storytelling. No matter your passion, there's a place for you on Biggestfan.",
    },
   
  ],
};

const Privacy = () => {
  return (
     <section className="relative pt-48 pb-24 z-0">
      <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl mx-auto px-4">
        <div className="space-y-12">

          {/* Title */}
          <div className="text-center space-y-3">
            <h1 className="text-4xl font-bold text-white">
              {privacyData.title}
            </h1>
            <p className="text-white/75 text-base leading-relaxed">
              {privacyData.description}
            </p>
          </div>

          {/* Sections */}
          <div className="space-y-8">
            {privacyData.sections.map((section, index) => (
              <div key={index} className="space-y-2">
                <h4 className="text-xl font-semibold text-white">
                  {section.heading}
                </h4>
                <div
                  className="text-white/75 text-base leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: section.body }}
                />
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default Privacy;
